import startTrix from './trix';
import lensCatalogue from './components/lensCatalogue';
import resourceTable from './components/resourceTable';
import selectComponent from './components/selectComponent';
import actionHandler from './components/actionHandler';
import resourceTableRowActions from './components/resourceTableRowActions';
import autocompleteField from './components/autocompleteField';
import pillsField from './components/pillsField';
import actionsDropdown from './components/actionsDropdown';
import resourceInfinit from './components/resourceInfinit';
import flatpickrField from './components/flatpickrField';
import colorPickerField from './components/colorPickerField';
import filterPanel from './components/filterPanel';
import avatarPicker from './components/avatarPicker';
import avatarRow from './components/avatarRow';
import quickFilterName from './components/quickFilterName';
import installActionDialogCommitGuard from './support/actionDialogCommitGuard';
import installNavigateMorphGuard from './support/navigateMorphGuard';
import installActionTriggerGuard from './support/actionTriggerGuard';
import ui from '@alpinejs/ui'
import Clipboard from '@ryangjchandler/alpine-clipboard'

export default (Alpine) => {
  const installLivewireSupport = () => {
    if (!globalThis.Livewire) return false

    installActionDialogCommitGuard(globalThis.Livewire)
    installNavigateMorphGuard(globalThis.Livewire)
    installActionTriggerGuard(globalThis.Livewire)

    return true
  }

  // The documented ESM setup exposes Livewire before initResourcerer() runs.
  // Keep a fallback for hosts that load the two scripts in the opposite order.
  if (!installLivewireSupport() && globalThis.document?.addEventListener) {
    globalThis.document.addEventListener('livewire:init', installLivewireSupport, { once: true })
  }

  Alpine.data('resourceTable', resourceTable)
  Alpine.data('lensCatalogue', lensCatalogue)
  Alpine.data('selectComponent', selectComponent)
  Alpine.data('actionHandler', actionHandler)
  Alpine.data('resourceTableRowActions', resourceTableRowActions)
  Alpine.data('autocompleteField', autocompleteField)
  Alpine.data('pillsField', pillsField)
  Alpine.data('actionsDropdown', actionsDropdown)
  Alpine.data('resourceInfinit', resourceInfinit)
  Alpine.data('flatpickrField', flatpickrField)
  Alpine.data('colorPickerField', colorPickerField)
  Alpine.data('filterPanel', filterPanel)
  Alpine.data('avatarPicker', avatarPicker)
  Alpine.data('avatarRow', avatarRow)
  Alpine.data('quickFilterName', quickFilterName)
  Alpine.plugin(ui)
  Alpine.plugin(Clipboard)

  Alpine.magic('morph', () => (from, to, options) => {
    Alpine.morph(from, to, options)
  })

  startTrix(Alpine);
}
